var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconEmail({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 13,
    viewBox: "0 0 17 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.5261 0.883057H2.47393C1.6419 0.883057 0.967407 1.51174 0.967407 2.28731V10.7128C0.967407 11.4884 1.6419 12.1171 2.47393 12.1171H14.5261C15.3581 12.1171 16.0326 11.4884 16.0326 10.7128V2.28731C16.0326 1.51174 15.3581 0.883057 14.5261 0.883057Z",
    stroke: "#0E1318",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.0326 2.98926L9.27587 6.99139C9.0433 7.12718 8.77442 7.19922 8.50002 7.19922C8.22561 7.19922 7.95674 7.12718 7.72416 6.99139L0.967407 2.98926",
    stroke: "#0E1318",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconEmail);
export default __webpack_public_path__ + "static/media/icon-email.2828ab1cc46ecf69a4383603e11d1cf1.svg";
export { ForwardRef as ReactComponent };